function defaultGetOptionValue(option) {
  return option?.value;
}

function addValues(selected, values) {
  const next = [...selected];
  values.forEach((value) => {
    if (value != null && !next.includes(value)) next.push(value);
  });
  return next;
}

function removeValues(selected, values) {
  const remove = new Set(values.filter((value) => value != null));
  return selected.filter((value) => !remove.has(value));
}

function resolveParentOption(options, option, value, getOptionValue) {
  if (option?.isParent) return option;
  if (option?.parent) {
    return options.find((candidate) => getOptionValue(candidate) === option.parent) || null;
  }
  return (
    options.find(
      (candidate) => candidate.isParent && (candidate.children || []).includes(value)
    ) || null
  );
}

/**
 * Parent/child checkbox rules:
 * - checking a parent selects the parent and every child
 * - unchecking a parent clears the parent and every child
 * - checking every child also selects the parent
 * - unchecking any child clears the parent and leaves the remaining children
 */
export function applyHierarchicalCheckboxChange({
  options = [],
  selected = [],
  option,
  value,
  checked,
  getOptionValue = defaultGetOptionValue,
}) {
  const parentOption = resolveParentOption(options, option, value, getOptionValue);
  const childValues = parentOption?.children || [];
  const parentValue = parentOption ? getOptionValue(parentOption) : null;
  const isHierarchical = Boolean(parentValue && childValues.length);

  if (!isHierarchical) {
    return checked ? addValues(selected, [value]) : removeValues(selected, [value]);
  }

  const isParentToggle = option?.isParent || value === parentValue;
  if (isParentToggle) {
    return checked
      ? addValues(selected, [parentValue, ...childValues])
      : removeValues(selected, [parentValue, ...childValues]);
  }

  if (checked) {
    const next = addValues(selected, [value]);
    const allChildrenSelected = childValues.every((child) => next.includes(child));
    return allChildrenSelected ? addValues(next, [parentValue]) : removeValues(next, [parentValue]);
  }

  return removeValues(selected, [value, parentValue]);
}
